enum Fields {
  Dropdown = 'dropdown',
  Program = 'program',
  TimePeriod = 'time_period',
  Search = 'search',
}

export default Fields
